<div class="customer-association-menu" (click)="$event.stopPropagation()">
  <!-- Top: search input without borders -->
  <div class="customer-association-menu__search">
    <ui-svg-icon svgIcon="search_icon" size="medium" class="customer-association-menu__search-icon"></ui-svg-icon>
    <input
      #searchInput
      type="text"
      class="customer-association-menu__search-input"
      [formControl]="searchControl"
      [placeholder]="'smart_inbox.inbox_view.customer_association_menu.placeholder_search' | translate"
      autofocus
    />
  </div>

  <hr class="separator" />

  <!-- Mid: scrollable list (backend pagination on scroll), company + location name -->
  <div class="customer-association-menu__list" (scroll)="onListScroll($event)">
    <ng-container *ngFor="let location of locationsList; trackBy: trackByLocationId">
      <button
        type="button"
        class="navbar-button customer-association-menu__item"
        (click)="selectCustomer(location)"
      >
        <span class="customer-association-menu__check-slot" *ngIf="updateType === 'single'">
          <mat-icon *ngIf="isSelected(location)" class="customer-association-menu__check">check</mat-icon>
        </span>
        <span class="customer-association-menu__item-name">{{ getLocationDisplayName(location) }}</span>
      </button>
    </ng-container>
    <div *ngIf="loading" class="customer-association-menu__loading-more">
      <ui-svg-icon svgIcon="refresh-cc" size="small" class="spin-animation"></ui-svg-icon>
      {{ 'smart_inbox.inbox_view.customer_association_menu.loading' | translate }}
    </div>
    <div *ngIf="hasMoreToLoad && !loading" class="customer-association-menu__loading-more">{{ 'smart_inbox.inbox_view.customer_association_menu.scroll_for_more' | translate }}</div>
    <div *ngIf="locationsList.length === 0 && !loading" class="customer-association-menu__empty">{{ 'smart_inbox.inbox_view.customer_association_menu.no_clients_found' | translate }}</div>
  </div>

  <!-- Bottom: Remove association -->
  <ng-container *ngIf="showRemove">
    <hr class="separator" />
    <button
      type="button"
      class="navbar-button customer-association-menu__remove"
      (click)="removeAssociation()"
    >
      <ui-svg-icon svgIcon="close-cc" size="medium"></ui-svg-icon>
      <span>{{ 'smart_inbox.inbox_view.customer_association_menu.remove_association' | translate }}</span>
    </button>
  </ng-container>
</div>
